import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import axios from 'axios';
import { toast } from 'react-toastify';
import CustomTabs from '../components/CustomTabs';
import HeadingCp from '../components/HeadingCp';
import InventoryTranModal from '../components/InventoryTranModal'; // wherever you placed it
import InventoryListCp from '../components/InventoryListCp';
import InventoryTransactionsCp from '../components/InventoryTransactionsCp';
import ProductListPage from './ProductListPage';
import POListPage from './POListPage'; // Assuming you have a Purchase Orders page
import { stringify } from 'postcss';
import CustomTabs2 from '../components/CustomTabs2';
import StageEquipmentListPage from './StageEquipmentListPage'; // Assuming you have a Stage Equipment List page
import EquipmentList from './EquipmentList';

const InventoryDashboard = () => {
  const apiUrl = process.env.REACT_APP_API_URL;
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [activeLink, setActiveLink] = useState('Inventory Dashboard');
  const [showModal, setShowModal] = useState(false);
  const [editData, setEditData] = useState(null);

  useEffect(() => {
    if (location.state && location.state.tab) {
      setActiveLink(location.state.tab);
    }
  }, [location]);

  useEffect(() => {
    fetchInventory();
  }, []);

  const fetchInventory = async () => {
    try {
      setLoading(true);
      // e.g., const res = await axios.get(...);
      // handle results
    } catch (error) {
      if (error.response?.status === 401) {
        toast.error('Session expired', { position: 'top-center' });
        navigate('/login');
      } else {
        toast.error('Error fetching data', { position: 'top-center' });
      }
    } finally {
      setLoading(false);
    }
  };

  const handleTransactions = () => setActiveLink('Transactions');
  const handleListView = () => setActiveLink('Inventory Dashboard');
  const handleProductListView = () => setActiveLink('Products');
  const handlePOListView = () => setActiveLink('Purchase Orders');
  const handleStageListView = () => setActiveLink('Stage');

  // Opens the modal for a new inspection
  const openNewInspection = () => {
    setEditData(null);
    setShowModal(true);
  };

  const openEditInspection = (row) => {
    setEditData(row);
    setShowModal(true);
  };

  const handleSubmitInspection = async (formData) => {
     if(formData.data.address === null || 
        formData.data.tech_inspection === null || 
        formData.data.start_time === null || 
        formData.data.jobnum === null || 
        formData.data.date === null) { 
          toast.error('Please fill all the required fields', { position: 'top-center' });
          return;
        }
    
    try {
      // For "edit" if formData.id is not null; else "new"
      const response = await axios.post(`${apiUrl}/fdny_crud.php`, formData, {
        headers: {
          'Content-Type': 'application/json',
        },
      });
      if (response.data.success) {
        toast.success('Inspection saved', { position: 'top-center' });
        setShowModal(false);
      } else {
        toast.error('Error saving inspection', { position: 'top-center' });
      }
    } catch (error) {
      console.error(error);
      toast.error('Error saving inspection', { position: 'top-center' });
    }
  };

  const tabs = [
    { label: 'Inventory Dashboard', onClick: handleListView },
    { label: 'Purchase Orders', onClick: handlePOListView },
    { label: 'Stage', onClick: handleStageListView },
    { label: 'Transactions', onClick: handleTransactions },
    { label: 'Products List', onClick: handleProductListView},
  ];


  return (
    <>
      <div className="mx-auto max-w-6xl sm:px-6 lg:px-8 py-10">
        <HeadingCp label="Inventory Dashboard" />
{/* 
         <div className="mt-4">
          <button onClick={openNewInspection}
            className="bg-blue-500 hover:bg-blue-600 text-white px-2 py-1 rounded text-sm">
              New Transaction
          </button>
        </div>       */}

        <CustomTabs2 tabs={tabs} activeTab={activeLink} />
        <br />
        {activeLink === 'Inventory Dashboard' && <InventoryListCp/>}
        {/* {activeLink === 'Products' && <ProductListPage/>} */}
        {activeLink === 'Products' && <EquipmentList/>}
        {activeLink === 'Transactions' && <InventoryTransactionsCp/>}
        {activeLink === 'Purchase Orders' && <POListPage/>}
        {activeLink === 'Stage' && <StageEquipmentListPage/>}
      </div>

      {/* The Modal */}
      <InventoryTranModal
        isOpen={showModal}
        onClose={() => setShowModal(false)}
        onSubmit={handleSubmitInspection}
        initialData={editData || {}} 
      />
    </>
  );
};

export default InventoryDashboard;
